<template>
  <main class="loading-container">
    <section class="loading-container__info">
      <div class="loading-container__info__circle">
        <FileTextSvg />
      </div>
      <div class="circle-wrap"></div>
      <p class="loading-container__info__message" v-if="showLabel">
        Lendo pedido médico...
      </p>
    </section>
  </main>
</template>

<script>
export default {
  props: {
    showLabel: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
.loading-container {
  display: flex;
  padding: 24px;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  align-content: center;

  &__info {
    flex: 1;
    padding: 28px 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__circle {
      margin: 16px 0;
      background-color: var(--color-slider-circle);
      width: 72px;
      height: 72px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      position: relative;

      &::after {
        content: '';
        width: 150%;
        height: 150%;
        background-image: conic-gradient(var(--color-slider) 120deg, var(--color-slider-circle) 90deg);
        border-radius: 50%;
        position: absolute;
        animation: rotate 2s linear infinite;
        z-index: 0;
      }

      &::before {
        content: '';
        width: 66px;
        height: 66px;
        background-color: var(--color-slider-circle);
        position: absolute;
        border-radius: 50%;
        z-index: 1;
      }

      svg {
        z-index: 2;

        path {
          fill: var(--color-slider);
        }
      }
    }

    &__message {
      font-family: "Dasa sans", sans-serif;
      font-weight: var(--font-weight-bold);
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      color: #161616b8;
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
</style>
